import { render, staticRenderFns } from "./baokuan.vue?vue&type=template&id=b406835a"
import script from "./baokuan.vue?vue&type=script&lang=js"
export * from "./baokuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports